import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableCopyButton from 'app/admin/model/component/TableCopyButton';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import WhatIfTableService from '../service/WhatIfTableService';

const config = {
	key: 'whatIfExpertTable',
	topic: 'whatIf',
	service: WhatIfTableService,
	editFormState: item => `/what-if-expert/edit/${item ? item.id : 'new'}`,
	rowButtonList: [{ key: 'copy', component: TableCopyButton, service: WhatIfTableService }],
	toolbarAction: ['filter', 'search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	filterFields: [
		{
			propertyName: 'group',
			propertyType: 'Long',
			type: 'IN'
		}
	],
	columns: [
		{
			key: 'name'
		},
		{
			key: 'group.name'
		},
		{
			key: 'aspect.name'
		},
		{
			key: 'created',
			type: 'dateTime'
		},

		{
			key: 'updated',
			type: 'dateTime'
		}
	]
};

function WhatIfExpertTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('whatIfExpertTable', reducer('whatIfExpertTable'))(WhatIfExpertTable);
